import {Mark} from "../TextHighlighter";
import TextSelection from "./TextSelection";

export default class Token {
    constructor(
        public readonly index: number,
        public readonly position: number,
        public readonly type: 'tag'|'word'|'space',
        public content: string,
    ) { }

    public selection?: TextSelection;
    public textSelect = false;

    public get mark(): Mark {
        return this.selection?.mark || "none"
    }


    getHtml(plusComment: boolean, hasComment: boolean): string {
        if (this.type === "tag") {
            return this.content;
        }

        const commentIcon = plusComment ? `<div class="addComment"><i class="icon icon-message-${hasComment?'draw':'plus'} text-light"></i></div>` : '';
        const hasCommentClass = hasComment ? 'has-comment' : '';
        const hasTextSelectionClass = this.textSelect ? 'text-selection' : ''

        return `<span class="t-${this.type} mark-${this.mark} ${hasCommentClass} ${hasTextSelectionClass}" data-index="${this.index}">${commentIcon}${this.content}</span>`;
    }
}
